import { CardZone } from './CardZone';

export type { TypeCardZoneProps } from './types';
export default CardZone;
